module.exports = __webpack_public_path__ + "img/close.6955f789.png";